<template>
  <section
    class="component-m42pon65"
    :mode="$root.mode"
    :class="{
      freeflow: fullyTransitionedFirstTime,
      animated: animated,
      invisible: !enabled,
    }"
    resmed-component-name="video_gallery_feature_story_6"
  >
    <!--  fill viewport -->
    <div class="component" v-if="['lg', 'xl', 'md'].includes($root.mode)">
      <h1 style="display: none">{{ acf.h1 }}</h1>

      <div
        class="stage"
        @wheel="onWheel"
        @touchmove="onTouchMove"
        @touchstart="onTouchStart"
      >
        <div
          class="info-container"
          :class="{ enabled: enabled }"
          @transitionend="readyCheck()"
        >
          <div class="body">
            <transition
              enter-active-class="fade-in-down"
              leave-active-class="fade-out-up"
              mode="out-in"
            >
              <div
                v-if="activeStory"
                :key="`s_${activeStoryIndex}_story_nav`"
                class="story-navigator animated -duration-8"
              >
                <div class="story-nav-arrows">
                  <button
                    :disabled="activeStoryIndex === 0"
                    @click="prevStory()"
                    class="icon-chevron-up"
                    type="button"
                  ></button>
                  <button
                    :disabled="acf.stories.length - 1 === activeStoryIndex"
                    class="icon-chevron-down"
                    @click="nextStory()"
                    type="button"
                  ></button>
                </div>
                <p class="story-nav-description">
                  Story {{ activeStoryIndex + 1 }} of {{ acf.stories.length }}
                </p>
              </div>
            </transition>
            <transition
              enter-active-class="fade-in-right"
              leave-active-class="fade-out-left"
              mode="out-in"
            >
              <h2
                v-if="activeStory"
                :key="`s_${activeStoryIndex}_title`"
                class="story-title animated -delay-1"
                v-html="activeStory.title"
              ></h2>
            </transition>
            <transition
              enter-active-class="fade-in-right"
              leave-active-class="fade-out-left"
              mode="out-in"
            >
              <p
                v-if="activeStory"
                :key="`s_${activeStoryIndex}_description`"
                class="story-description animated -delay-2"
              >
                {{ activeStory.description }}
              </p>
            </transition>
            <transition
              enter-active-class="fade-in-right"
              leave-active-class="fade-out-left"
              mode="out-in"
            >
              <a
                v-if="activeStory"
                :key="`s_${activeStoryIndex}_ctatext`"
                href="javascript:void(0);"
                class="
                  animated
                  -delay-3
                  story-link
                  btn
                  cta-pill
                  filled-red
                  icon
                  right-arrow
                "
                @click.prevent="
                  presentModal(
                    activeStory.cta.video_player,
                    activeStory.cta.video_id,
                    activeStory.cta.aprimo_url,
                    activeStory.cta.aprimo_subtitle,
                    activeStory.cta.subtitles
                  )
                "
                type="button"
                >{{ activeStory.cta.text }}</a
              >
            </transition>
          </div>
        </div>
        <div
          class="image-container"
          :class="{ enabled: enabled }"
          @transitionend="flagVisible()"
        >
          <transition
            enter-active-class="fade-in"
            leave-active-class="fade-out"
            mode="in-out"
          >
            <div
              :key="activeImageStory.image"
              class="img-bg animated -absolute"
              :style="`background-image: url(${
                ['md', 'lg'].includes($root.mode)
                  ? activeImageStory.image_alt
                  : activeImageStory.image
              })`"
            ></div>
          </transition>
          <button
            v-if="activeStory"
            class="story-play"
            @click="
              presentModal(
                activeStory.cta.video_player,
                activeStory.cta.video_id,
                activeStory.cta.aprimo_url,
                activeStory.cta.aprimo_subtitle,
                activeStory.cta.subtitles
              )
            "
            :class="{ enabled: enabled }"
          >
            <img :src="`${path}/big-red-play-button.png`" />
          </button>
        </div>
      </div>
    </div>

    <!-- show all stacked -->
    <div
      class="component"
      v-if="['xs', 'sm'].includes($root.mode)"
      v-for="(story, idx) in acf.stories"
    >
      <div class="stage">
        <div
          class="info-container"
          :class="{ enabled: enabled }"
          @transitionend="readyCheck()"
        >
          <div class="body">
            <div class="story-navigator animated -duration-8">
              <p class="story-nav-description -has-eyebrow">
                Story {{ idx + 1 }} of {{ acf.stories.length }}
              </p>
            </div>
            <h2 class="story-title animated -delay-1" v-html="story.title"></h2>
            <p class="story-description animated -delay-2">
              {{ story.description }}
            </p>
            <a
              href="javascript:void(0);"
              class="
                animated
                -delay-3
                story-link
                btn
                cta-pill
                filled-red
                icon
                right-arrow
              "
              @click.prevent="
                presentModal(story.cta.video_player, story.cta.video_id, story.cta.aprimo_url, story.cta.aprimo_subtitle, story.cta.subtitles)
              "
              type="button"
              >{{ story.cta.text }}</a
            >
          </div>
        </div>
        <div
          class="image-container"
          :class="{ enabled: enabled }"
          @transitionend="flagVisible()"
        >
          <div
            :key="story.image"
            class="img-bg animated -absolute"
            :style="`background-image: url(${story.image})`"
          ></div>
          <button
            v-if="story"
            class="story-play"
            :class="{ enabled: enabled }"
            @click="presentModal(story.cta.video_player, story.cta.video_id, story.cta.aprimo_url, story.cta.aprimo_subtitle, story.cta.subtitles)"
          >
            <img :src="`${path}/big-red-play-button.png`" />
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ImageHelpers from "../../mixins/image-helpers";

if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

export default {
  name: "component-m42pon65", // video_gallery_feature_story_6
  props: ["acf"],
  mixins: [ImageHelpers],
  data() {
    return {
      enabled: false,
      animated: true,
      activeStoryIndex: null,
      activeImageStoryIndex: 0,
      hasReachedLastStory: false,
      fullyTransitionedFirstTime: false,
      transitionLocked: false,
      mousewheelSwipeThreshold: 30,
      touchStart: { x: 0, y: 0 },

      path: "@/assets/images",
    };
  },
  computed: {
    activeStory() {
      try {
        return this.acf.stories[this.activeStoryIndex] || null;
      } catch (e) {
        return null;
      }
    },
    activeImageStory() {
      try {
        return this.acf.stories[this.activeImageStoryIndex] || null;
      } catch (e) {
        return null;
      }
    },
  },
  watch: {
    enabled(v, o) {
      if (!o && v) {
        setTimeout(() => {
          $("body").addClass("overflow-hidden-m42pon65");
        }, 0);
      }
    },
    activeStoryIndex(v) {
      this.hasReachedLastStory =
        this.hasReachedLastStory || this.acf.stories.length === v + 1;
    },
    transitionLocked(v) {
      if (!v && this.hasReachedLastStory) {
        this.fullyTransitionedFirstTime = true;
      }
    },
    fullyTransitionedFirstTime(v) {
      if (v) {
        $("body").removeClass("overflow-hidden-m42pon65");
      }
    },
  },
  created() {
    bus.$on(
      "video_gallery_intro_animation_bgimg_title:complete",
      ({ shouldAnimate }) => {
        this.enabled = true;
        this.animated = shouldAnimate;

        if (!shouldAnimate) {
          this.readyCheck();
          this.flagVisible();
        }
      }
    );

    this.preloadImages([
      ...this.acf.stories.map((s) => s.image).filter((i) => i),
      `${this.path}/big-red-play-button.png`,
      `${this.path}/icon-down-chevron-red.svg`,
      `${this.path}/icon-up-chevron-red.svg`,
    ]);

    $(window).on("resize", () => {
      if (["lg", "xl"].includes(this.$root.mode) && !this.hasReachedLastStory) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    });
  },
  methods: {
    onTouchStart(e) {
      this.touchStart = { x: e.touches[0].pageX, y: e.touches[0].pageY };
    },
    onTouchMove(e) {
      this.onWheel({ deltaY: this.touchStart.y - e.touches[0].pageY });
    },
    onWheel(e) {
      let deltaY = e.deltaY;

      if (e.deltaMode === WheelEvent.DOM_DELTA_LINE) {
        deltaY = deltaY * 10; // no way to get this value easily, using a reasonable default
      } else if (e.deltaMode === WheelEvent.DOM_DELTA_PAGE) {
        deltaY = deltaY * 800; // no way to get this value easily, using a reasonable default
      }

      if (
        ["lg", "xl", "md"].includes(this.$root.mode) &&
        !this.fullyTransitionedFirstTime &&
        this.enabled
      ) {
        if (deltaY >= this.mousewheelSwipeThreshold) {
          this.nextStory();
        } else if (deltaY <= -this.mousewheelSwipeThreshold) {
          this.prevStory();
        }
      }
    },
    nextStory() {
      if (
        this.transitionLocked ||
        this.activeStoryIndex === this.acf.stories.length - 1
      ) {
        return;
      }

      this.transitionLocked = true;
      this.activeStoryIndex =
        this.activeStoryIndex + 1 >= this.acf.stories.length
          ? 0
          : this.activeStoryIndex + 1;
      this.activeImageStoryIndex = this.activeStoryIndex;

      setTimeout(() => {
        this.transitionLocked = false;
      }, 1300);
    },
    prevStory() {
      if (this.transitionLocked || this.activeStoryIndex === 0) {
        return;
      }

      this.transitionLocked = true;
      this.activeStoryIndex =
        this.activeStoryIndex - 1 < 0
          ? this.acf.stories.length - 1
          : this.activeStoryIndex - 1;
      this.activeImageStoryIndex = this.activeStoryIndex;

      setTimeout(() => {
        this.transitionLocked = false;
      }, 1300);
    },
    readyCheck() {
      if (this.activeStoryIndex === null) {
        this.activeStoryIndex = this.activeImageStoryIndex;
      }
    },
    flagVisible() {
      if (this.enabled) {
        bus.$emit("video_gallery_feature_story_6:visible");
      }
    },
    presentModal(player, videoId, aprimoUrl, aprimoSubtitle, subtitles) {
      bus.$emit("overlay:active", {
        player: player,
        id: videoId,
        aprimo_url: aprimoUrl || null,
        aprimo_subtitle: aprimoSubtitle || null,
        subtitles: subtitles || null,
        active: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-m42pon65 {
  background-position: center center;
  background-repeat: no-repeat;
  position: fixed;
  z-index: 10;
  top: 9.5rem;
  left: 0;
  right: 0;
  bottom: 0;

  &:not(.animated) {
    background: $cc-resmed-white;
  }

  @media (max-width: 991px) {
    top: 6rem;
  }

  @media (max-width: 767px) {
    top: 4rem;
  }

  &.freeflow {
    position: static;
    padding-top: 7.5rem;
    height: auto;

    @media (min-width: 1200px) {
      height: calc(100vh - 2rem);
    }

    @media (max-width: 991px) {
      padding-top: 0;
    }
  }

  .animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
    animation-delay: 0s;

    &.-delay-1 {
      animation-delay: 0.1s;
    }

    &.-delay-2 {
      animation-delay: 0.2s;
    }

    &.-delay-3 {
      animation-delay: 0.3s;
    }

    &.-duration-8 {
      animation-duration: 0.8s;
    }

    &.-absolute {
      position: absolute;
    }
  }

  .fade-in-right {
    animation-name: fade-in-right;
  }

  .fade-out-left {
    animation-name: fade-out-left;
  }

  .fade-in-down {
    animation-name: fade-in-down;
  }

  .fade-out-up {
    animation-name: fade-out-up;
  }

  .fade-in {
    animation-name: fade-in;
  }

  .fade-out {
    animation-name: fade-out;
  }

  .component {
    height: 100%;
    position: relative;
    background-color: $cc-resmed-grey-10;

    .story-navigator {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;

      .story-nav-description {
        font-family: "Plus Jakarta Sans", sans-serif;
        font-weight: 700;
        position: relative;

        &.-has-eyebrow {
          @extend %eyebrow-left;
        }
      }

      .story-nav-arrows {
        display: flex;
        flex-direction: column;
        margin-right: 1rem;
        height: 4.5rem;
        justify-content: space-between;

        button {
          width: 1rem;
          height: 0.5rem;
          padding: 0.9rem;

          &.icon-chevron-down {
            background: rgba(255, 255, 255, 0)
              url("#{$assets}/images/icon-down-chevron-red.svg") no-repeat
              center;
          }

          &.icon-chevron-up {
            background: rgba(255, 255, 255, 0)
              url("#{$assets}/images/icon-up-chevron-red.svg") no-repeat center;
          }

          &:disabled {
            opacity: 0.5;
            cursor: default;
          }
        }
      }
    }

    .story-play {
      position: absolute;
      bottom: 0;
      transform: translate(-50%, -25%);
      background: rgba(255, 255, 255, 0);
      width: 160px;
      height: 160px;
      opacity: 0;

      transition: opacity 0.6s;
      transition-delay: 1s;

      &.enabled {
        opacity: 1;
      }

      img {
        width: 100%;
        height: auto;
      }
    }

    .stage {
      display: flex;

      @media (min-width: 1200px) {
        height: 100%;
      }

      .info-container {
        width: 50%;
        background-color: $cc-resmed-grey-10;
        transform: translate3d(0, 100%, 0);
        transition: transform 1s cubic-bezier(0.22, 0.76, 0, 0.96);

        &.enabled {
          transform: translate3d(0, 0, 0);
        }

        .body {
          padding: 4rem 4rem 4rem 30%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;
          align-items: flex-start;

          .story-title {
            margin-bottom: 0.5em;
            font-size: 2.375em;
            max-width: 100%;
          }

          .story-link {
            margin-right: auto;
            margin-top: 1rem;
          }

          .story-description {
            overflow: auto;
            flex: 0 1 auto;
            line-height: 1.5;
            max-width: 100%;
          }
        }
      }

      .image-container {
        width: 50%;
        transform: translate3d(0, 100%, 0);
        transition: transform 1s cubic-bezier(0.22, 0.76, 0, 0.96);
        transition-delay: 0.2s;
        background-color: $cc-resmed-grey-10;

        &.enabled {
          transform: translate3d(0, 0, 0);
        }

        .img-bg {
          background-size: cover;
          width: 100%;
          height: 100%;
          background-position: 70% top;

          @media (min-width: 768px) and (max-width: 1099px) {
            background-position: center top;
            height: 410px;
          }
        }
      }
    }
  }

  // mobile & tablet
  &[mode="xs"],
  &[mode="sm"],
  &[mode="md"],
  &[mode="lg"] {
    .stage {
      flex-direction: column-reverse;

      .info-container,
      .image-container {
        width: 100%;
      }

      .image-container {
        height: 40vh;
        flex: 0 1 auto;
        transform: translate3d(100%, 0, 0);
      }

      .info-container {
        flex: 1 0 auto;
        transform: translate3d(100%, 0, 0);

        .body {
          padding: 5rem;
          justify-content: flex-start;
        }
      }
    }

    .component {
      .story-play {
        left: 7rem;
        top: 100%;
        width: 120px;
        height: 120px;
        transform: translate(-50%, -50%);
      }
    }
  }

  &[mode="md"],
  &[mode="lg"] {
    .stage {
      .image-container {
        height: 410px;
      }
    }
  }

  &[mode="xs"],
  &[mode="sm"] {
    position: relative;
    top: 0 !important;
    padding-top: 7.5rem;

    @media (max-width: 991px) {
      padding-top: 0;
    }

    .stage {
      .info-container {
        .body {
          padding: 5rem 2rem;
        }
      }
    }
  }
}
</style>

<style>
@media (min-width: 768px) {
  body.overflow-hidden-m42pon65 {
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>